module.exports = __webpack_public_path__ + "img/badge-most-conversion-keyvue-green.0c7c8824.png";